import { render, staticRenderFns } from "./SymptomsParts.vue?vue&type=template&id=4e7ba6d2&scoped=true"
import script from "./SymptomsParts.vue?vue&type=script&lang=js"
export * from "./SymptomsParts.vue?vue&type=script&lang=js"
import style0 from "./SymptomsParts.vue?vue&type=style&index=0&id=4e7ba6d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7ba6d2",
  null
  
)

export default component.exports